import React from 'react';
import PropTypes from 'prop-types';

HeroPill.propTypes = {
  children: PropTypes.node
};

export default function HeroPill(props) {
  const { children } = props;

  return (
    <span className="inline-flex items-center justify-center
                     bg-cs-navy-600 text-white
                     font-normal uppercase
                     text-xl leading-[30px]
                     px-4 py-[5px] rounded-full
                     whitespace-nowrap select-none">
      {children}
    </span>
  );
}
